import React from 'react'
import { useMutation } from '@tanstack/react-query'
import { Modal } from '../../../../../components/common/Modal'
import { useAppTranslation } from '../../../../../hooks/useAppTranslation'
import { ModalHeader } from '../../../../../components/common/Modal/ModalHeader'
import { ModalBody } from '../../../../../components/common/Modal/ModalBody'
import { DeleteUserModalContent } from './DeleteUserModalContent'
import { useToastNotifications } from '../../../../../hooks/useToastNotification'
import { ToastType } from '../../../../../components/common/Toast/toast-type'
import { Spinner } from '../../../../../components/common/Spinner'
import { deleteUser } from '../../../../../api/admin'
import { IUserModel } from '../../../../../interfaces/models/users.interfaces'

interface DeleteUserModalProps {
  show: boolean
  close: () => void
  resetSearchResult: () => void
  user: IUserModel
}

export const DeleteUserModal = ({
  show,
  close,
  user,
  resetSearchResult,
}: DeleteUserModalProps): React.ReactNode => {
  const { translate } = useAppTranslation()
  const { setToastNotification } = useToastNotifications()

  const { mutate: mutateDeleteUser, isPending: isDeletingUser } = useMutation({
    mutationFn: deleteUser,
    onSuccess: () => {
      resetSearchResult()
      close()
      setToastNotification(ToastType.SUCCESS, 'Användare raderad')
    },
    onError: () => {
      setToastNotification(
        ToastType.DANGER,
        translate('flashMessage.somethingWentWrongError')
      )
    },
  })

  const onSubmit = async (): Promise<void> => {
    mutateDeleteUser({ userId: user._id })
  }

  return (
    <Modal show={show}>
      {{
        header: <ModalHeader onClose={close}>Radera användare</ModalHeader>,
        body: (
          <ModalBody className="max-h-96 overflow-y-auto">
            {isDeletingUser ? (
              <Spinner />
            ) : (
              <DeleteUserModalContent
                onSubmit={onSubmit}
                onClose={close}
                user={user}
              />
            )}
          </ModalBody>
        ),
      }}
    </Modal>
  )
}
